import React from 'react';
import {View} from 'react-native';
import {AnimatedCircularProgress} from 'react-native-circular-progress';
import CCColors from '@/Utils/CCColors';

interface Props {
  percent: number;
  size?: number;
  ringWidth?: number;
  active?: boolean;
  children: React.ReactNode;
}

// Wraps an avatar (or any child) in a thin onboarding-completion ring.
// Renders the child bare once complete (percent >= 100) or when inactive, so a
// finished user sees no ring at all.
export default function OnboardingRing({
  percent,
  size = 50,
  ringWidth = 3,
  active = true,
  children,
}: Props) {
  if (!active || percent >= 100) {
    return <>{children}</>;
  }
  return (
    <AnimatedCircularProgress
      size={size}
      width={ringWidth}
      fill={Math.max(0, Math.min(100, percent))}
      rotation={0}
      lineCap="round"
      tintColor={CCColors.Login.Gold}
      backgroundColor={CCColors.Login.Border}>
      {() => (
        <View style={{justifyContent: 'center', alignItems: 'center'}}>
          {children}
        </View>
      )}
    </AnimatedCircularProgress>
  );
}
